// Specifies overriding values for translations
import cz from './cz';

export {cz};
